// extracted by mini-css-extract-plugin
module.exports = {"container":"input-envelope_container__X09h8"};